export default __webpack_public_path__ + "static/Plain-Medium-721ef3770fb579f4d6d022f0b50c47c0.woff2";